import { PageContainer } from '../../../shared/PageContainer';
import { useFeedback, ListAndDetail } from "@sis/react-library"
import ListIcon from '@mui/icons-material/List';
import { listAndDetailSamplesRoutes } from "../../ListAndDetailSamplesNavigation";
import { useState } from "react";
import { callMimicApi } from "../../../../utils/commonUtils";
import { CityTownDto } from "../../../sampleData/sampleDataReducer";
import { useSampleData } from "../../../sampleData/useSampleData";
import LocationCityIcon from '@mui/icons-material/LocationCity';
import { Box, ListItemIcon, ListItemText } from '@mui/material';
import { ListAndDetailSamplesCustomRenderPageInfo } from './ListAndDetailSamplesCustomRenderPageInfo';

export const ListAndDetailSamplesCustomRenderPage = () => {

  const { cityTowns, deleteCityTowns } = useSampleData();
  const [deleting, setDeleting] = useState(false);

  const { showSuccess, showError } = useFeedback();

  const handleDelete = async (cityTownsToDelete: CityTownDto[]) => {
    try {
      // In the api call, uncomment the exception in there to test errors coming from the api
      setDeleting(true);

      await callMimicApi();
      await deleteCityTowns(cityTownsToDelete);

      setDeleting(false);
      showSuccess('The countries were deleted');
    } catch (ex) {
      showError(`An error occured: ${ex}`);
    }
  }


  const listItemRender = (item: CityTownDto, hasSelection: boolean) =>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '34px', paddingTop: '4px' }}><ListItemIcon><LocationCityIcon /></ListItemIcon></Box>
      {/* Has selection indicates wether a selection has been made (so the list will be narrower) */}
      {/* In this example we are only showing country code if there is no selection (because it is wider) */}
      {!hasSelection &&
        <>{item.countryCode} - &nbsp;</>
      }
      <ListItemText
        sx={{ color: item.countryCode === "UK" ? 'blue' : undefined }}
      >
        {item.description}
      </ListItemText>
    </Box>

  return (
    <PageContainer
      heading='List Samples - Overwrite Render'
      icon={<ListIcon />}
      pageInfo={<ListAndDetailSamplesCustomRenderPageInfo />}
    >
      <ListAndDetail
        items={cityTowns}
        keyValue={(item: CityTownDto) => item.code}
        ////////////////////////////////////////////////////////////////////////////////////////////////////////
        // You can override the list render if you like. 
        // This example adds a city icon and makes the option blue if it's a UK city/town.
        ////////////////////////////////////////////////////////////////////////////////////////////////////////
        itemRender={listItemRender}
        searchFields={['code', 'description']}
        listUrl={listAndDetailSamplesRoutes.customRender}
        newUrl={listAndDetailSamplesRoutes.new}
        editUrl={listAndDetailSamplesRoutes.edit}
        deleteOptions={{
          onDelete: handleDelete,
          busyDeleting: deleting
        }}
      />
    </PageContainer>
  )
}
